import { defineStore } from "pinia";
import { useCookies } from "@vueuse/integrations/useCookies";
import { COOKIE_SETTINGS } from "@/utils/cookies";
import { reactive, computed } from "vue";

const COOKIE_KEY = "new-feature-announcement";
const cookies = useCookies();

export const useFeatureAnnouncementStore = defineStore(
  "featureAnnouncement",
  () => {
    const views = reactive<Record<string, number>>(
      cookies.get(COOKIE_KEY) ?? {},
    );

    const wasShown = reactive<Record<string, boolean>>({});

    const canShow = (feature: string, maxViews = 1) =>
      computed(() => {
        const currentViews = views[feature] ?? 0;
        const alreadyShown = wasShown[feature] ?? false;
        return currentViews < maxViews && !alreadyShown;
      });

    const increment = (feature: string) => {
      const currentViews = views[feature] ?? 0;
      views[feature] = currentViews + 1;
      cookies.set(COOKIE_KEY, views, COOKIE_SETTINGS);
    };

    const markAsShown = (feature: string) => {
      wasShown[feature] = true;
    };

    return {
      views,
      wasShown,
      canShow,
      increment,
      markAsShown,
    };
  },
);
